export default __webpack_public_path__ + "89cf2d1d2ef2833fcade8d6b6eff0c54.png";